const getFormId = ({ productNumber, formCode }) => {
  if (!productNumber || !formCode) {
    return;
  }
  return `${productNumber}/${formCode.toLowerCase()}`;
};

export default getFormId;
